import { Component, Fragment } from "react";
import ListSelectField from "../fields/ListSelectField";
import LineItemListSelect from "./LineItemListSelect";


class LineItemListSelectFieldGroup extends Component {
    constructor(props) {
        super(props)

        this.state = {
            subtypeUsageByType: {
                "service": false,
                "part": false,
                "other": false,
                "discount": false,
                "tax": false,
            },
        }
    }

    async componentDidMount() {
        const endpoint = DjangoUrls["pricebook:api-pricebookitem-subtypes-usage-by-type"](window.MARKETPLACE_ENTITY_SLUG)

        try {
            const response = await fetch(endpoint)
            const data = await response.json()
            this.setState({ subtypeUsageByType: data })
        } catch (error) {
            console.error("Error fetching subtype choices:", error);
        }
    }

    render = () => {
        const {
            object,
            labelPrefix="",
            formatCurrencyValue,
            showSummaryHint=false,
            showQuickBooksItemSelect=false,
            useTaxes=false,
            switchToSecondaryForm,
            errors,
            nonFieldErrorMessage,
            isEstimateLineItem=false,
            isJobLineItem=false,
            isInvoiceLineItem=false,
            isPurchaseOrderLineItem=false,
            isBillLineItem=false,
            isCreditNoteLineItem=false,
            isVendorCreditLineItem=false,
            parentLineItems=[],
            parentLineItemFieldName="",
            parentLineItemLabel="",
            hideAddButton=false,
        } = this.props

        return (
            <Fragment>
                <div className="data-panel__form__field" id="div_id_line_items" aria-label="Line Item Errors" style={errors.line_items ?  {"display": "initial"} : {"display": "none"}}>
                    {errors.line_items && <div className="data-panel__form__field__errors text-centered" aria-label="Field Errors">{nonFieldErrorMessage}</div>}
                </div>
                {!isPurchaseOrderLineItem && (
                <ListSelectField
                    fieldName="service_charges"
                    fieldLabel={`${labelPrefix}Service Charges`}
                    inputComponent={
                        <LineItemListSelect
                            fieldName="service_charges"
                            onSelect={data => switchToSecondaryForm("EDIT_SERVICE_CHARGE", data, null)}
                            parent={object}
                            items={object.service_charges || []}
                            formatCurrencyValue={formatCurrencyValue}
                            showSummaryHint={showSummaryHint}
                            showQuickBooksItemSelect={showQuickBooksItemSelect}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            isVendorCreditLineItem={isVendorCreditLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            hasSubtypeChoices={this.state.subtypeUsageByType["service"]}
                        ></LineItemListSelect>
                    }
                    showButton={!hideAddButton}
                    buttonLabel="Add Service Charge"
                    buttonAction={event => switchToSecondaryForm("ADD_SERVICE_CHARGE", null, null)}
                    errors={errors}
                ></ListSelectField>
                )}
                <ListSelectField
                    fieldName="parts"
                    fieldLabel={`${labelPrefix}Parts and Materials`}
                    inputComponent={
                        <LineItemListSelect
                            fieldName="parts"
                            onSelect={data => switchToSecondaryForm("EDIT_PART", data, null)}
                            parent={object}
                            items={object.parts || []}
                            formatCurrencyValue={formatCurrencyValue}
                            showQuickBooksItemSelect={showQuickBooksItemSelect}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            isVendorCreditLineItem={isVendorCreditLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            hasSubtypeChoices={this.state.subtypeUsageByType["part"]}
                        ></LineItemListSelect>
                    }
                    showButton={!hideAddButton}
                    buttonLabel="Add Part or Material"
                    buttonAction={event => switchToSecondaryForm("ADD_PART", null, null)}
                    optional={true}
                    optionalText="if any"
                    errors={errors}
                ></ListSelectField>
                {!isPurchaseOrderLineItem && (
                <ListSelectField
                    fieldName="other_charges"
                    fieldLabel={`${labelPrefix}Trip Charges, Diagnostic Fees, etc.`}
                    inputComponent={
                        <LineItemListSelect
                            fieldName="other_charges"
                            onSelect={data => switchToSecondaryForm("EDIT_OTHER_CHARGE", data, null)}
                            parent={object}
                            items={object.other_charges || []}
                            formatCurrencyValue={formatCurrencyValue}
                            showQuickBooksItemSelect={showQuickBooksItemSelect}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            isVendorCreditLineItem={isVendorCreditLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            hasSubtypeChoices={this.state.subtypeUsageByType["other"]}
                        ></LineItemListSelect>
                    }
                    showButton={!hideAddButton}
                    buttonLabel="Add Miscellaneous Charge"
                    buttonAction={event => switchToSecondaryForm("ADD_OTHER_CHARGE", null, null)}
                    optional={true}
                    optionalText="if any"
                    errors={errors}
                ></ListSelectField>
                )}
                {!isPurchaseOrderLineItem && !isCreditNoteLineItem && !isVendorCreditLineItem && (
                <ListSelectField
                    fieldName="discounts"
                    fieldLabel={`${labelPrefix}Discounts`}
                    inputComponent={
                        <LineItemListSelect
                            fieldName="discounts"
                            onSelect={data => switchToSecondaryForm("EDIT_DISCOUNT", data, null)}
                            parent={object}
                            items={object.discounts || []}
                            formatCurrencyValue={formatCurrencyValue}
                            showQuickBooksItemSelect={showQuickBooksItemSelect}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            isVendorCreditLineItem={isVendorCreditLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            hasSubtypeChoices={this.state.subtypeUsageByType["discount"]}
                        ></LineItemListSelect>
                    }
                    showButton={!hideAddButton}
                    buttonLabel="Add Discount"
                    buttonAction={event => switchToSecondaryForm("ADD_DISCOUNT", null, null)}
                    optional={true}
                    optionalText="if any"
                    errors={errors}
                ></ListSelectField>
                )}
            </Fragment>
        )
    }
}

export default LineItemListSelectFieldGroup;
